import { LogLevel, getLogger } from '@ori/checkout-utils';
import { TranslationsNamespaceProvider, TranslationsProvider } from '@ori/i18n';
import { Team, TestIdProvider } from '@ori/testid-generator';
import { Suspense, type FC, StrictMode } from 'react';

import { APP_NAME, translationsNamespace } from './constants';
import { ApiProvider, SubscriptionTypesContainer, WizardContainer } from './containers';
import { ConfigurationProvider } from './contexts/configurationContext';
import type { AppConfiguration } from './types/AppConfiguration';
import { getTranslationsProps } from './utils';

export interface AppProps {
  readonly configuration: AppConfiguration;
}

const logDebug = getLogger(APP_NAME, LogLevel.Debug);
const componentName = 'SubscriptionWizardController.tsx';

export const SubscriptionWizardController: FC<AppProps> = ({ configuration }) => {
  const translationProps = getTranslationsProps(configuration);
  logDebug(
    `Rendering ${componentName} ...`,
    '\n\tConfiguration: ',
    configuration,
    '\n\tTranslationProps: ',
    translationProps,
  );

  return (
    <StrictMode>
      <Suspense fallback={null}>
        <TestIdProvider
          team={Team.Checkout}
          project={APP_NAME}
        >
          <ConfigurationProvider value={configuration}>
            <ApiProvider>
              <TranslationsProvider {...translationProps}>
                <TranslationsNamespaceProvider namespace={translationsNamespace}>
                  <WizardContainer>
                    <SubscriptionTypesContainer />
                  </WizardContainer>
                </TranslationsNamespaceProvider>
              </TranslationsProvider>
            </ApiProvider>
          </ConfigurationProvider>
        </TestIdProvider>
      </Suspense>
    </StrictMode>
  );
};
